import { defaultPageTitleOptions } from "config/constants";
import { IHeader } from "config/types";

import { UnknownAction } from "@reduxjs/toolkit";
import { get } from "lodash-es";

import * as t from "../constants";

const defaultState: IHeader = {
  type: "default",
  title: defaultPageTitleOptions,
};

const header = (state: IHeader = defaultState, action: UnknownAction) => {
  const payload = get(action, "payload");
  switch (action.type) {
    case t.SET_HEADER:
      return { ...state, ...(get(payload, "header") as unknown as Partial<IHeader>) };
    case t.RESET_MODAL:
      return { ...state, ...defaultState };
    default:
      return state;
  }
};

export default header;
